import React from 'react'
import ConfirmModalContainer from './container'
// import { removeUserAdminData, removeUserData, useLogoutMutation } from 'pages/login/services';
import { useDispatch, useSelector } from 'react-redux';
// import { useDeleteUserMutation } from 'pages/userList/services';
import { messageNotification } from 'utils/function';
import { useNavigate } from 'react-router-dom';
import { removePOSData, useLogoutMutation } from 'pages/login/services';
// import { useDeleteWelcomePlansMutation } from 'pages/welcomePlans/services';
// import { useDeleteRegularPlansMutation } from 'pages/regularPlans/services';

const ConfirmModal = ({handleClose, confirmData}) => {
    const [logOut] = useLogoutMutation();
    // const [deleteUser] = useDeleteUserMutation();
    // const [deleteWelcomePlans] = useDeleteWelcomePlansMutation();
    // const [deleteRegularPlans] = useDeleteRegularPlansMutation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

      const confirmLogoutHandler = async () => {
        await logOut();
        dispatch(removePOSData());
        handleClose();
      };
   
      const deleteHandler = async (id) => {
        // if(confirmData.pageId == "welcome-plans-list"){
        //   const deleteResponse = await deleteWelcomePlans(id);
        //   if(deleteResponse.data?.status) {
        //     messageNotification(deleteResponse.data.message, "success");
        //     handleClose();
        //   } else {
        //     messageNotification(deleteResponse.error.data.message, "error");
        //   }
        // } else if(confirmData.pageId == "regular-plans-list"){
        //   const deleteResponse = await deleteRegularPlans(id);
        //   if(deleteResponse.data?.status) {
        //     messageNotification(deleteResponse.data.message, "success");
        //     handleClose();
        //   } else {
        //     messageNotification(deleteResponse.error.data.message, "error");
        //   }
        // } else {
        //   const deleteResponse =  await deleteUser(id);
        //    if (deleteResponse.data?.status) {
        //      navigate("/user-listing");
        //      messageNotification(deleteResponse.data.message, "success");
        //      handleClose();
        //    } else {
        //      messageNotification(deleteResponse.error.data.message, "error");
        //    }
        // }
      }
   

  return (
    <div>
      <ConfirmModalContainer 
        handleClose={handleClose} 
        handleLogOut={confirmLogoutHandler} 
        handleDelete={deleteHandler}
        confirmData={confirmData}
      />
    </div>
  )
}

export default ConfirmModal
